import { GiftCard } from "ui/giftcards/types/giftcard.types";
import CategoryChip from "../categoryChip/CategoryChip";
import { GifCardSegementGrid, GiftCardContainer, GiftCardSegmentRoot, ImgGiftCard, GiftCardBorder } from "./GiftCardSegment.styles";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import { Link } from "react-router-dom";
import { CSSProperties } from "react";

type GiftCardSegmentProps = {
    title: string;
    data: GiftCard[];
};

function GiftCardSegment({ title, data }: GiftCardSegmentProps) {
    return (
        <GiftCardSegmentRoot className="gif-card-segment">
            <CategoryChip category={title} />
            <GifCardSegementGrid>
                {data
                    .filter((giftCard) => giftCard.activo === 1)
                    .map((el) =>
                        el.sourceType === "APPRECIO" ? (
                            <GiftCardLink key={el.catalog_id} giftCard={el} />
                        ) : (
                            <GiftCardContainer key={el.catalog_id}>
                                <GiftCardBorder>
                                    <GiftCardLink key={el.catalog_id} giftCard={el} />
                                </GiftCardBorder>
                            </GiftCardContainer>
                        ),
                    )}
            </GifCardSegementGrid>
        </GiftCardSegmentRoot>
    );
}

const GiftCardLink = ({ giftCard }: { giftCard: GiftCard }) => {
    const imgStyle: CSSProperties = { display: "flex", justifyContent: "center", borderRadius: "8px" };
    return (
        <Link style={imgStyle} to={`${MainRoutes.GIFT_CARDS}/${giftCard.catalog_id}?source=${giftCard.sourceType}`}>
            <ImgGiftCard src={giftCard.imagenGiftcardPNG} alt={giftCard.giftcard} />
        </Link>
    );
};

export default GiftCardSegment;
